import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
const routes = [{
    path: "/",
    redirect: "/index",
    meta: {}
  },
  {
    path: "/index",
    name: "index",
    component: resolve => require(['@/views/index.vue'],resolve),
    meta: {
      title:''
    }
  },
  {
    path: "/login",
    name: "login",
    component: resolve => require(['@/views/login.vue'],resolve),
    meta: {
      title:'登录'
    }
  },
  {
    path: "/login_old",
    name: "login_old",
    component: resolve => require(['@/views/login_old.vue'],resolve),
    meta: {
      title:'登录'
    }
  },
  {
    path: "/city",
    name: "city",
    component: resolve => require(['@/views/city.vue'],resolve),
    meta: {
      title:'城市'
    }
  },
];

const router = new VueRouter({
  routes
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router;